import { Step, StepButton, Stepper } from '@mui/material';
import cn from 'clsx';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';

import CompetedIcon from '@/assets/icons/CompetedIconSmall.svg';
// 由于大小和线条粗细不同，所以重新引入icon
import StepErrorIcon from '@/assets/icons/StepErrorIconSmall.svg';

import styles from './index.module.scss';

import { NodeStatusListVo } from '@/apis/afterSales/afterSales.interface';

interface stepBarProps {
  step: number;
  stepList: NodeStatusListVo[];
}

const stepBar: React.FC<stepBarProps> = observer(({ step, stepList }) => {
  if (!stepList.length) {
    return null;
  }
  const [activeStep, setActiveStep] = useState(0);
  useEffect(() => {
    // step-1，因为他是从0开始
    setActiveStep(Math.min(Math.floor(step - 1), stepList.length));
  }, [step]);

  return (
    <div className={styles.step_wrap}>
      <Stepper nonLinear activeStep={activeStep}>
        {stepList.map((ele, index) => {
          // type 1为已完成，对号样式，2为当前状态，红底白字，3为未到达状态，白底黑字，4为已拒绝或者已取消状态，叉号样式
          const isCompleted = ele?.type === 1;
          return (
            <Step key={index} disabled completed={isCompleted}>
              <StepButton
                icon={
                  ele?.type === 4 ? (
                    <StepErrorIcon color='#CC0C1C' width={24} height={24} />
                  ) : isCompleted ? (
                    <CompetedIcon color='#CC0C1C' width={24} height={24} />
                  ) : undefined
                }
              >
                <div
                  className={cn(styles.step_label, {
                    [styles.error_step_label]: ele?.type === 4,
                  })}
                >
                  {ele.text}
                </div>
              </StepButton>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
});

export default stepBar;
